import { downloadBlobFromApi } from '../../helpers'
import apiService from '../Api'
import {
  IEventSurveyConfig,
  IEventSurveyDeliveryPreview,
  IEventSurveyDispatchPayload,
  IEventSurveyDispatchResult,
  IEventSurveyEvent,
  IEventSurveyPayload,
  IEventSurveyReport,
  IEventSurveyResponsesPage
} from './surveyTypes'

/** Pesquisa NPS de evento (ABRA-370): configuração, relatório e respostas. */
export class EventSurveyService {
  /** Evento pelo slug, liberado para as permissões da pesquisa (o detalhe exige view_events). */
  async getEvent(slug: string): Promise<IEventSurveyEvent> {
    return apiService.get(`/events/slug/${encodeURIComponent(slug)}/survey/event`).then((res) => res.data)
  }

  async getConfig(eventId: number): Promise<IEventSurveyConfig> {
    return apiService.get(`/events/${eventId}/survey`).then((res) => res.data)
  }

  async saveConfig(eventId: number, payload: IEventSurveyPayload): Promise<IEventSurveyConfig> {
    return apiService.put(`/events/${eventId}/survey`, payload).then((res) => res.data)
  }

  async deliveryPreview(eventId: number): Promise<IEventSurveyDeliveryPreview> {
    return apiService.get(`/events/${eventId}/survey/delivery-preview`).then((res) => res.data)
  }

  async dispatch(eventId: number, payload: IEventSurveyDispatchPayload): Promise<IEventSurveyDispatchResult> {
    return apiService.post(`/events/${eventId}/survey/dispatch`, payload).then((res) => res.data)
  }

  /** 404 quando o evento ainda não tem pesquisa configurada. */
  async report(eventId: number): Promise<IEventSurveyReport> {
    return apiService.get(`/events/${eventId}/survey/report`).then((res) => res.data)
  }

  async responses(
    eventId: number,
    params: { page: number; page_size: number; search?: string }
  ): Promise<IEventSurveyResponsesPage> {
    const { search, ...rest } = params

    return apiService
      .get(`/events/${eventId}/survey/responses`, { params: { ...rest, ...(search ? { search } : {}) } })
      .then((res) => res.data)
  }

  async deleteResponse(eventId: number, responseId: number): Promise<{ message: string }> {
    return apiService.delete(`/events/${eventId}/survey/responses/${responseId}`).then((res) => res.data)
  }

  async exportXlsx(eventId: number, eventSlug: string, search = ''): Promise<void> {
    // downloadBlobFromApi não repassa `params`, então a busca vai montada na própria URL.
    const query = search ? `?${new URLSearchParams({ search }).toString()}` : ''

    return downloadBlobFromApi(
      `/events/${eventId}/survey/responses/export-xlsx${query}`,
      `pesquisa-nps-${eventSlug}.xlsx`
    )
  }
}
